import TbComPerson from "domain/main/com/person/TbComPerson";
import TbCommCorpBizLic from "domain/main/comm/corp/biz/lic/TbCommCorpBizLic";
import TbCommCorp from "domain/main/comm/corp/TbCommCorp";
import { action, observable, set } from "mobx";

/**
 * 기업 관리 Model
 */
export default class CorperationManageModel {
  @observable private editable!: boolean;
  @observable private tbCommCorp: TbCommCorp;
  @observable private tbComPerson: TbComPerson;
  @observable private acctNo: string = "";
  @observable private tbCommCorpBizLicList: TbCommCorpBizLic[];

  public constructor(data?) {
    set(this, data);

    this.tbCommCorp = new TbCommCorp(data?.tbCommCorp || {});
    this.tbComPerson = new TbComPerson(data?.tbComPerson || {});
    if (data?.tbCommCorpBizLicList != null) {
      this.tbCommCorpBizLicList = data?.tbCommCorpBizLicList.map((tbCommCorpBiz) => new TbCommCorpBizLic(tbCommCorpBiz));
    } else {
      this.tbCommCorpBizLicList = [];
    }
  }

  public isEditable(): boolean {
    return this.editable;
  }
  public getTbCommCorp(): TbCommCorp {
    return this.tbCommCorp;
  }
  @action
  public setTbCommCorp(tbCommCorp: TbCommCorp): void {
    this.tbCommCorp = tbCommCorp;
  }

  public getTbCommCorpBizLicList(): TbCommCorpBizLic[] {
    return this.tbCommCorpBizLicList;
  }
  @action
  public setTbCommCorpBizLicList(tbCommCorpBizLicList: TbCommCorpBizLic[]): void {
    this.tbCommCorpBizLicList = tbCommCorpBizLicList;
  }

  public getTbComPerson(): TbComPerson {
    return this.tbComPerson;
  }
  @action
  public setTbComPerson(tbComPerson: TbComPerson): void {
    this.tbComPerson = tbComPerson;
  }

  public getAcctNo(): string {
    return this.acctNo;
  }
  @action
  public setAcctNo(acctNo: string): void {
    this.acctNo = acctNo;
  }
}
